<template>
  <requests />
</template>

<script>
import Requests from '@/views/requests/components/requests'
import ContentMixin from '@/mixins/content-mixin'

export default {
  name: 'requestsView',
  components: {
    Requests
  },
  mixins: [
    ContentMixin
  ],
  beforeRouteLeave (to, from, next) {
    this.ContentMixin_Leave(next)
  }
}
</script>
